export enum Cin7OmniBomImportStrategy {
  IMPORT_PARENT_AND_CHILDREN = "import_parent_and_children",
  IMPORT_PARENT = "import_parent",
}

export enum Cin7OmniSalesOrderStage {
  NEW = "New",
  AWAITING_PAYMENT = "Awaiting Payment",
  PROCESSING = "Processing",
  RELEASE_TO_PICK = "Release To Pick",
  PARTIALLY_PICKED = "Partially Picked",
  FULLY_PICKED = "Fully Picked",
  FULLY_PICKED_HOLD = "Fully Picked - Hold",
  ON_HOLD = "On Hold",
  DISPATCHED = "Dispatched",
  CANCELLED = "Cancelled",
  RELEASE_TO_PICK_WMS = "Release To Pick - WMS",
  READY_TO_PACK_WMS = "Ready To Pack - WMS",
}
